import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import CountryChart from "app/components/charts/CountryChart";

import {
    FormControl,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";

class RegionalMigration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countryData: null,
            topology: null
        }

    }

    componentDidMount = () => {
        fetch(
            'https://code.highcharts.com/mapdata/countries/us/us-all.topo.json'
        ).then(response => response.json()).then((json) => {
            this.setState({ topology: json });
        });
        // this.props.regionalMigrationData.forEach(item => {
        //     item.custom = {
        //         stateName: item.state,
        //         emigration: item.emigration,
        //         immigration: item.immigration,
        //     };
        //     item.value = item.net_migration_maps;
        //     });
        // this.setState({ countryData: this.props.regionalMigrationData});

    }

    render() {
        let countryData = this.props.regionalMigrationData;
        countryData.forEach(item => {
            item.custom = {
                stateName: item.state,
                emigration: item.emigration,
                immigration: item.immigration,
                net_migration_maps: item.net_migration_maps
            };
            item.value = item.map_value;
        });

        var value_label_map = {}

        countryData.forEach(item => {
            value_label_map[item.map_value] = item.net_migration_maps
        });

        value_label_map[1] = value_label_map["1.00"]
        value_label_map[0] = value_label_map["0.00"]
        value_label_map[-1] = value_label_map["-1.00"]

        const { topology, someData } = this.state;
        var maxValue;
        var minValue;

        if (countryData) {
            maxValue = getMax(countryData, "value");
            minValue = getMin(countryData, "value");
        }

        return (
            <div className="graph-wrapper screen-left-graph-container">
                <div className="graph-title-container-screen graph-title-container-screen3">
                </div>
                <div className="graph-screen">
                    <div className="map-title">Regional Migration</div>
                    {topology && countryData ? <CountryChart
                        containerId={"migrationMap"}
                        height={"600px"}
                        topology={topology} data={countryData}
                        colorAxis={{
                            min: minValue,
                            max: maxValue,
                            minColor: '#91003f',
                            maxColor: '#034e7b',
                            stops: [
                                [0, '#91003f'],
                                [0.1, "#ce1256"],
                                [0.2, "#e7298a"],
                                [0.3, "#df65b0"],
                                [0.4, "#c994c7"],
                                [0.49, "#d4b9da"],
                                [0.5, '#F1EEF6'],
                                [0.51, '#a6bddb'],
                                [0.6, "#74a9cf"],
                                [0.7, "#3690c0"],
                                [0.8, "#0570b0"],
                                [1, "#034e7b"],
                            ],
                            labels: {
                                formatter: function () {
                                    return value_label_map[this.value]  
                                }
                            },
                            tickPositions: [-1, 1],
                        }}
                        tooltipFormatter={
                            function () {
                                let tooltip = 'State: <b>' + this.point.custom.stateName + '</b><br>';
                                tooltip += 'Left AZ: <b>' + this.point.custom.emigration + '</b><br>';
                                tooltip += 'Moved to AZ: <b>' + this.point.custom.immigration + '</b><br>';
                                tooltip += 'Net Migration: <b>' + this.point.custom.net_migration_maps + '</b>';
                                return tooltip;
                            }
                        }
                    /> : null}
                </div>
            </div>
        );
    }
}

function getMax(arr, prop) {
    var max;
    for (var i = 0; i < arr.length; i++) {
        if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
            max = arr[i];
    }
    return max[prop];
}

function getMin(arr, prop) {
    var min;
    for (var i = 0; i < arr.length; i++) {
        if (min == null || parseInt(arr[i][prop]) < parseInt(min[prop]))
            min = arr[i];
    }
    return min[prop];
}

export default RegionalMigration;
